import React from 'react';
import '../styles/privacy-policy.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-container">
      <div className="content-wrapper">
        <h1>Privacy Policy</h1>
        <p>Last Updated: July 1, 2025</p>

        <section>
          <h2>Introduction</h2>
          <p>
            Welcome to Burger Barn. We respect your privacy and are committed to protecting your personal data.
            This privacy policy will inform you about how we look after your personal data when you visit our website
            and tell you about your privacy rights and how the law protects you.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
          <ul>
            <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
            <li><strong>Contact Data</strong> includes billing address, delivery address, email address and telephone numbers.</li>
            <li><strong>Technical Data</strong> includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
            <li><strong>Usage Data</strong> includes information about how you use our website, products and services.</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
          <ul>
            <li>To process and deliver your order.</li>
            <li>To manage our relationship with you.</li>
            <li>To improve our website, products/services, marketing, or customer relationships.</li>
            <li>To make recommendations to you about goods or services that may be of interest to you.</li>
          </ul>
        </section>
        
        <section>
          <h2>Communications and Marketing</h2>
          <p>
            By providing your phone number to Burger Barn and/or interacting with our business number (provided by Grasshopper), 
            you consent to receive calls or text messages at the number provided. Message frequency varies.
          </p>
          <p>
            This consent is not a condition of any purchase. You can opt out of receiving communications at any time by:
          </p>
          <ul>
            <li>Replying STOP to any text message you receive</li>
            <li>Notifying our staff when you receive a call</li>
            <li>Contacting us directly at burgerbarnbearlake@gmail.com</li>
          </ul>
          <p>
            Standard message and data rates may apply. We do not charge you for calls or texts, however charges may be incurred from your wireless provider.
          </p>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>
            We have put in place appropriate security measures to prevent your personal data from being accidentally lost, 
            used or accessed in an unauthorized way, altered or disclosed.
          </p>
        </section>

        <section>
          <h2>Third-Party Services</h2>
          <p>
            We use Grasshopper as our business phone service provider. When you interact with our business through this service,
            your interactions may be subject to Grasshopper's privacy policies in addition to our own.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>Email: burgerbarnbearlake@gmail.com</p>
          <p>Phone: (435) 288-3693</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
